import { GraphQLClient } from "../../../../../shared/gql-client";
import * as gqlBuilder from "gql-query-builder";
import { gql } from "@apollo/client";
import { RouteModel } from "../../domain/models/routeModel";
import { PackingSlipModel } from "../../domain/models/packingSlipModel";

export default class PackingSlipService {
  private client: GraphQLClient | undefined;

  setClient(client: GraphQLClient) {
    this.client = client;
  }

  mutate(input: object): Promise<RouteModel | null> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "upsertPackingSlip",
        variables: input,
        fields: ["id"],
      });

      this.client
        ?.mutate("upsertPackingSlip", gql(query), variables)
        .then((response) => {
          const data = response as RouteModel;

          if (!data.id) {
            resolve(null);
          }

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  delete(id: string): Promise<PackingSlipModel | null> {
    return new Promise((resolve, reject) => {
      const { query, variables } = gqlBuilder.mutation({
        operation: "deletePackingSlip",
        variables: {
          id: {
            name: "id",
            type: "ID!",
            value: id,
          },
        },
        fields: ["id"],
      });

      this.client
        ?.mutate("deletePackingSlip", gql(query), variables)
        .then((response) => {
          const data = response as PackingSlipModel;

          if (!data.id) {
            resolve(null);
          }

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
